import { useEffect, useState } from 'react';
export function useClientInitStatus(client) {
    const [clientStatus, setClientStatus] = useState(() => ({
        isLocalDataLoaded: false,
        isRemoteDataLoaded: false,
        streamSyncActive: false,
        isHighPriorityDataLoaded: false,
    }));
    useEffect(() => {
        if (!client) {
            return;
        }
        const updateStreamSyncActive = (active) => {
            setClientStatus((prev) => {
                if (prev.streamSyncActive === active) {
                    return prev;
                }
                else {
                    return {
                        ...prev,
                        streamSyncActive: active,
                    };
                }
            });
        };
        const updateClientInitStatus = (status) => {
            // This code intentionally ignore the progress field
            // to reduce the number of re-renders
            setClientStatus((prev) => {
                if (status.isLocalDataLoaded === prev.isLocalDataLoaded &&
                    status.isRemoteDataLoaded === prev.isRemoteDataLoaded &&
                    status.isHighPriorityDataLoaded === prev.isHighPriorityDataLoaded) {
                    return prev;
                }
                else {
                    return {
                        isLocalDataLoaded: status.isLocalDataLoaded,
                        isRemoteDataLoaded: status.isRemoteDataLoaded,
                        streamSyncActive: prev.streamSyncActive,
                        isHighPriorityDataLoaded: status.isHighPriorityDataLoaded,
                    };
                }
            });
        };
        updateClientInitStatus(client.clientInitStatus);
        updateStreamSyncActive(client.streamSyncActive);
        client.on('streamSyncActive', updateStreamSyncActive);
        client.on('clientInitStatusUpdated', updateClientInitStatus);
        return () => {
            client.off('streamSyncActive', updateStreamSyncActive);
            client.off('clientInitStatusUpdated', updateClientInitStatus);
        };
    }, [client]);
    return clientStatus;
}
//# sourceMappingURL=useClientInitStatus.js.map